// Import general mixin for shared functionality.
import mixin from './mixin';

const ShopDetailApp = {
    mixins: [mixin],
    data() {
        return {
            dataId: '',
            dataName: '',
            dataPrice: 0,
            dataImagesrc: '',
            dataImagecrops: '',
            dataFocalpoint: '',
            dataFileurl: '',
            dataUrl: '',
            dataCartUrl: '',
            amount: 1,
            cart: [],
        }
    },
    computed: {
        product() {
            return this.cart.find(product => product.id === this.dataId);
        }
    },
    methods: {
        init() {
            if (this.$el.dataset.id) this.dataId = this.$el.dataset.id;
            if (this.$el.dataset.name) this.dataName = this.$el.dataset.name;
            if (this.$el.dataset.price) this.dataPrice = parseFloat(this.$el.dataset.price.replace(',', '.'));
            if (this.$el.dataset.imagesrc) this.dataImagesrc = this.$el.dataset.imagesrc;
            if (this.$el.dataset.imagecrops) this.dataImagecrops = this.$el.dataset.imagecrops;
            if (this.$el.dataset.focalpoint) this.dataFocalpoint = this.$el.dataset.focalpoint;
            if (this.$el.dataset.fileurl) this.dataFileurl = this.$el.dataset.fileurl;
            if (this.$el.dataset.url) this.dataUrl = this.$el.dataset.url;
            if (this.$el.dataset.carturl) this.dataCartUrl = this.$el.dataset.carturl;

            if (localStorage.getItem('cart')) {
                this.cart = JSON.parse(localStorage.getItem('cart'));
                if (this.product) this.amount = this.product.amount;
            }

            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: "EUR",
                    value: this.dataPrice,
                    items: [
                        {
                            item_id: this.dataId,
                            item_name: this.dataName,
                            price: this.dataPrice,
                            quantity: 1
                        }
                    ]
                }
            });
        },
        minusOne() {
            if (this.amount == 1) return;
            this.amount--;
        },
        addToCart() {
            if (this.product) this.cart = this.cart.filter(product => product.id != this.dataId);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: "EUR",
                    value: this.dataPrice * this.amount,
                    items: [
                        {
                            item_id: this.dataId,
                            item_name: this.dataName,
                            price: this.dataPrice,
                            quantity: this.amount
                        }
                    ]
                }
            });
            this.cart.push({
                id: this.dataId,
                name: this.dataName,
                price: this.dataPrice,
                imagesrc: this.dataImagesrc,
                imagecrops: this.dataImagecrops,
                focalpoint: this.dataFocalpoint,
                url: this.dataUrl,
                amount: this.amount,
            });
            localStorage.setItem('new', this.dataId);
            localStorage.setItem('cart', JSON.stringify(this.cart));
            window.location.href = this.dataCartUrl;
        }
    },
    mounted() {
        this.init();
    },
};

export default ShopDetailApp;
